import * as types from '../mutation-types'

const state = {
  search: JSON.parse(localStorage.getItem('orders_set_order_search'))
}

const mutations = {
  [types.ORDERPROGRESS_SET_ORDER_RESET] (state) {
    state.search = null
    localStorage.removeItem('orders_set_order_search')
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tracking.js